import { DocumentTypeCodes } from '@core/enumerations';
import { TenantNames } from '@mynexus/mynexus-ui-lib';
import { SendFaxDocumentTypeConfig } from '@core/services/send-fax/send-fax-base.service';

export default {
  [TenantNames.Anthem]: {
    mailOnly: true,
    exclude: [
      DocumentTypeCodes.P2P,
      DocumentTypeCodes.DismissalNoAOR,
      DocumentTypeCodes.ReopenedApproval,
      DocumentTypeCodes.DecisionTimeframeExtension
    ]
  },
  [TenantNames.Aetna]: {
    mailOnly: true,
    exclude: [
      DocumentTypeCodes.P2P
    ]
  },
  [TenantNames.Humana]: {
    exclude: [
      DocumentTypeCodes.SPT,
      DocumentTypeCodes.ReopenedApproval,
      DocumentTypeCodes.DecisionTimeframeExtension
    ]
  },
  [TenantNames.Regence]: {
    mailOnly: true,
    exclude: [
      DocumentTypeCodes.P2P,
      DocumentTypeCodes.SPT,
      DocumentTypeCodes.DismissalNoAOR,
      DocumentTypeCodes.ReopenedApproval,
      DocumentTypeCodes.DecisionTimeframeExtension
    ]
  },
  [TenantNames.UnitedHealthcare]: {
    mailOnly: true,
    exclude: [
      DocumentTypeCodes.P2P,
      DocumentTypeCodes.SPT,
      DocumentTypeCodes.DismissalNoAOR,
      DocumentTypeCodes.ReopenedApproval,
      DocumentTypeCodes.DecisionTimeframeExtension
    ]
  },
  [TenantNames.BCBSRI]: {
    mailOnly: true,
    exclude: [
      DocumentTypeCodes.P2P,
      DocumentTypeCodes.DismissalNoAOR,
      DocumentTypeCodes.ReopenedApproval,
      DocumentTypeCodes.DecisionTimeframeExtension
    ]
  },
} satisfies SendFaxDocumentTypeConfig;
